module.exports = __webpack_public_path__ + "img/logo.c2ba567f.png";